import type { TimeHTMLAttributes } from 'react';
import { usePage } from '@inertiajs/react';

import { AccountTimeZoneDate, BrowserTimeZoneDate } from '@/components/ui/date';
import { useIsPageEditor } from '@/hooks/use-is-page-editor';
import type { SharedData } from '@/types/shared';

type ContentDateProps = Omit<TimeHTMLAttributes<HTMLTimeElement>, 'dateTime' | 'children'> & {
  value: string | number | Date;
};

export function ContentDate({ value, ...props }: ContentDateProps) {
  const isPageEditor = useIsPageEditor();
  const { site } = usePage<SharedData>().props;

  return isPageEditor ? (
    <AccountTimeZoneDate value={value} timeZone={site?.timeZoneIdentifier} {...props} />
  ) : (
    <BrowserTimeZoneDate value={value} fallbackTimeZone={site?.timeZoneIdentifier} {...props} />
  );
}
